<template>
  <div id="dashboard">
    <v-container fluid>
      <v-row align="center" class="mt-n9">
        <v-col class="text-center" cols="12" sm="12">
          <v-card-subtitle class="text-center"
            ><h1>Productos y Servicios</h1></v-card-subtitle
          >
        </v-col>
      </v-row>

      <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item
          v-for="(cliente, i) in clientes"
          :key="i"
          :color="cliente.color"
          :icon="cliente.icon"
          fill-dot
        >
          <template v-slot:opposite>
            <span>{{ cliente.anio }}</span>
          </template>
          <v-card :color="cliente.color" dark justify="center">
            <v-card-title class="title"> {{ cliente.cliente }}</v-card-title>
            <v-card-text class="white text--primary text-center">
              <img :src="cliente.logo" class="mt-2" />
              <img
                v-if="cliente.logo2"
                :src="cliente.logo2"
                class="mt-2 ml-4"
              />
            </v-card-text>
            <v-card-text class="white text--primary text-start">
              <v-btn
                :color="cliente.color"
                class="mx-0"
                outlined
                @click="cliente.action = !cliente.action"
              >
                Más
              </v-btn>
              <v-btn
                :color="cliente.color"
                icon
                @click="cliente.action = !cliente.action"
              >
                <v-icon>{{
                  cliente.action ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </v-card-text>
            <v-expand-transition>
              <div v-show="cliente.action">
                <v-divider></v-divider>

                <v-card-text>
                  <span v-if="cliente.text1">{{ cliente.text1 }}</span>
                  <ul v-if="cliente.acciones">
                    <li
                      v-bind:key="i"
                      v-for="(item, i) in cliente.acciones"
                    >
                      {{ item.actividad }}
                    </li>
                  </ul>
                  <span v-if="cliente.text2">{{ cliente.text2 }}</span>
                  <ul v-if="cliente.actividades2">
                    <li
                      v-bind:key="i"
                      v-for="(item, i) in cliente.actividades2"
                    >
                      {{ item.actividad }}
                    </li>
                  </ul>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-timeline-item>
      </v-timeline>
      <v-row align="center" class="mx-1">
        <div class="my-2">
          <v-btn
            depressed
            large
            rounded
            color="primary white--text"
            to="/timeline"
            >Anterior</v-btn
          >
        </div>
        <v-spacer></v-spacer>
        <div class="my-2">
          <v-btn
            depressed
            large
            rounded
            color="primary white--text"
            to="/references"
            >Siguiente</v-btn
          >
        </div>
      </v-row>
    </v-container>
    <pageFooter></pageFooter>
  </div>
</template>
<script>
import pageFooter from "@/components/Footer.vue";
import header from "@/components/header.vue";
export default {
  components: {
    pageFooter,
  },
  data() {
    return {
      clientes: [
        {
          color: "grey darken-3",
          icon: "mdi-star",
          cliente: "Dharma",
          logo: "images/productos/dharma.png",
          anio: "2020",
          action: false,
          text1:
            "Sistema de gestión de negocio que cuenta con los siguientes módulos:",
          acciones: [
            { actividad: "Clientes" },
            {
              actividad:
                "Ventas",
            },
            { actividad: "Cuentas por cobrar" },
            {
              actividad:
                "Cuentas por pagar",
            },
            
            { actividad: "Inventarios" },
            {
              actividad:
                "e-commerce",
            },
          ],
          text2: "Asimismo, cuenta con dos verticales:",
          actividades2: [
            { actividad: "Sistema Integral de SPA" },
            {
              actividad:
                "RM para profesionales de Seguros, Fianzas e Inversión",
            },
          ],
        },
        {
          color: "amber accent-4",
          icon: "mdi-star",
          cliente: "Bo'ol",
          logo: "images/productos/logotipo.png",
          anio: "2020",
          action: false,
          text1:
            "Sistema de gestión de recursos humanos, cuenta con los siguientes módulos:",
          actividades2: [
            { actividad: "Dashboard" },
            { actividad: "NOM-035" },
            { actividad: "Gestión de Vacaciones e Incidencias" },
            { actividad: "Adelanto de nómina mediante una financiera" },
            { actividad: "Captación de Talento" },
            { actividad: "Generación de CFDI" },
          ],
        },
        {
          color: "blue-grey",
          icon: "mdi-star",
          cliente: "Fabrica de software",
          logo: "images/productos/abadia.png",
          anio: "2020",
          action: false,
          text1: "Por qué somos una mejor opción:",
          actividades2: [
            { actividad: "Casos de uso claros y precisos." },
            { actividad: "Documentación de código" },
            {
              actividad:
                "Utilización de DevOp (metodología ágil de desarrollo)	Utilización de DevOp (metodología ágil de desarrollo)",
            },
            { actividad: "Prototipo de usabilidad y diseño" },
            { actividad: "Arquitectura multidispositivo basado en Xamarin" },
            { actividad: "Arquitecto de Base de Datos" },

            { actividad: "Desarrollo basado en diseño y funcionalidad  UX/UI" },
            { actividad: "Pruebas unitarias e integrales reales" },

            { actividad: "Pruebas UAT" },
            { actividad: "Entrega del código fuentes sin costo extra" },
          ],
        },
      ],
    };
  },
  methods: {},
  created() {},
};
</script>
